import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateLoginUser = {
  loginUser: { data: null, loading: false, error: null },
};

export const loginUser = createAsyncThunk('user/loginUser', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .post(`${process.env.REACT_APP_SERVER_API}/auth/login`, {
      type: 'staff',
      email: data.email,
      password: data.password,
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerLoginUser = {
  [loginUser.pending]: (state) => {
    state.loginUser.loading = true;
    state.loginUser.error = null;
  },
  [loginUser.fulfilled]: (state, action) => {
    state.loginUser.loading = false;
    state.loginUser.data = action.payload;
    state.loginUser.error = null;
  },
  [loginUser.rejected]: (state, action) => {
    state.loginUser.loading = false;
    state.loginUser.error = action.payload;
  },
};
